import { Select } from "antd";
import { useAppSelector, useAppDispatch } from "../store/hooks";
import { selectJoint, setJoint } from "../store/slices/configurationSlice";
import { JOINTS } from "../constants";
import { JointRow } from "./Menu/JointRow";

const JointPicker = () => {
  const dispatch = useAppDispatch();
  const joint = useAppSelector(selectJoint);

  return (
      <Select
        value={joint.name}
        popupClassName="joint-select-popup"
        onChange={(val) => {
          const selectedJoint = JOINTS.find((j) => j.name === val);
          if (selectedJoint) {
            dispatch(setJoint(selectedJoint));
          }
        }}
        labelRender={() => (
          <div style={{ padding: "8px 0" }}>
            <JointRow joint={joint} />
          </div>
        )}
      >
        {JOINTS.map((j) => (
          <Select.Option key={j.name} value={j.name}>
          <JointRow
            key={j.name}
            joint={j}
          />
          </Select.Option>
        ))}
      </Select>
  );
};

export default JointPicker;
